export const createSimplePrompt = (responses, language) => {
    if (language === 'FR') {
        return createFrenchPrompt(responses);
    }
    if (language === 'ES') {
        return createSpanishPrompt(responses);
    }
    return createEnglishPrompt(responses);
};

const createEnglishPrompt = (responses) => {
    let prompt = 'A respondent has provided the following response to a survey:\n\n';
    
    // Find the open-ended response
    Object.keys(responses).forEach((key) => {
        if (responses[key].type === 'open_ended') {
            prompt += `Response: ${responses[key].response}\n\n`;
        }
    });

    prompt += `## TASK:
Your goal is to generate a simple follow-up question that will help gather slightly deeper context and insights into the initial response. The point of the question we are asking to figure out an initial pain point, and then a simple version of what is causing that pain point and/or why it is critical to solve. Lastly, act like a consultant that is doing a very high level discovery conversation in order to eventually provide a recommendation.
Guidelines:
- Every response will be about a pain point (i.e., what they find difficult, annoying, time consuming, etc.), so always focus on digging deeper into that pain point and any other relevant information about it that would be helpful for us to know.
- Don't ask about what we can do to improve, only ask about their experience or thoughts, under the assumption their experience is generally negative
- We are collecting feedback at a conference from HR professionals, so don't ask about specific examples or situations they mentioned
- Your goal is to gather better context, and generally the pain point, of the respondent's original response
- Be curious about the cause of their pain point, not solution focused or optimistic
- Keep the question simple and clear (10th grade reading level)
- Generate only the question itself, no additional text
- Make it feel conversational and intuitive to reply to 

Question:`;



    return prompt;
};

const createFrenchPrompt = (responses) => {
    let prompt = 'Un répondant a fourni la réponse suivante à une enquête organisationnelle:\n\n';
    
    Object.keys(responses).forEach((key) => {
        if (responses[key].type === 'open_ended') {
            prompt += `Réponse: ${responses[key].response}\n\n`;
        }
    });

    prompt += `## TÂCHE:
Votre objectif est de générer une question de suivi réfléchie qui aidera à recueillir des insights plus profonds sur l'expérience du répondant.

Directives:
- Concentrez-vous sur la compréhension du "pourquoi" derrière leur réponse
- Demandez des exemples spécifiques ou des situations qu'ils ont mentionnées
- Explorez les solutions potentielles ou les améliorations qu'ils pourraient suggérer
- Soyez empathique et encourageant dans votre approche
- Gardez la question simple et claire (niveau de lecture 7e année)
- Générez seulement la question elle-même, pas de texte supplémentaire
- Faites en sorte que ce soit conversationnel et de soutien

Question:`;

    return prompt;
};

const createSpanishPrompt = (responses) => {
    let prompt = 'Un encuestado ha proporcionado la siguiente respuesta a una encuesta organizacional:\n\n';
    
    Object.keys(responses).forEach((key) => {
        if (responses[key].type === 'open_ended') {
            prompt += `Respuesta: ${responses[key].response}\n\n`;
        }
    });

    prompt += `## TAREA:
Su objetivo es generar una pregunta de seguimiento reflexiva que ayude a recopilar información más profunda sobre la experiencia del encuestado.

Pautas:
- Concéntrese en entender el "por qué" detrás de su respuesta
- Pregunte sobre ejemplos específicos o situaciones que mencionaron
- Explore soluciones potenciales o mejoras que podrían sugerir
- Sea empático y alentador en su enfoque
- Mantenga la pregunta simple y clara (nivel de lectura de 7mo grado)
- Genere solo la pregunta en sí, sin texto adicional
- Haga que se sienta conversacional y de apoyo

Pregunta:`;

    return prompt;
}; 